var ContactFormBlock = /** @class */ (function () {
    function ContactFormBlock(element) {
        this.formContainer = element;
        this.inputs = Array.from(this.formContainer.querySelectorAll('.gfield input'));
        this.datepicker = Array.from(this.formContainer.querySelectorAll('.gfield--type-date'));
        this.addEventListeners();
    }
    ContactFormBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.inputs.forEach(function (input) { return input.addEventListener('input', _this.inputListener.bind(_this)); });
        document.addEventListener('DOMContentLoaded', function () { return _this.datepicker.forEach(function (datepicker) { return _this.datePickerListener(datepicker); }); });
    };
    ContactFormBlock.prototype.datePickerListener = function (datepicker) {
        var label = datepicker.querySelector('label');
        var input = datepicker.querySelector('input');
        // @ts-ignore
        jQuery(input).datepicker({
            onSelect: function (dateText) {
                // @ts-ignore
                jQuery(label).addClass('active');
            }
        });
    };
    ContactFormBlock.prototype.inputListener = function (event) {
        var currentInput = event.currentTarget;
        var currentItem = event.currentTarget;
        var elementParent = currentItem.parentElement;
        var elementWrapper = currentItem.parentElement.parentElement;
        // for fieldset items
        if (elementParent.tagName === 'SPAN') {
            elementWrapper = elementParent;
        }
        var label = elementWrapper.querySelector('label');
        if (currentInput.value.trim() === '') {
            label.classList.remove('active');
        }
        else {
            label.classList.add('active');
        }
    };
    return ContactFormBlock;
}());
var contactFormBlocks = document.querySelectorAll('[data-contact-form-block]');
contactFormBlocks.forEach(function (contactForm) {
    new ContactFormBlock(contactForm);
});
